<fin-loyalty-view
  data-hj-suppress
  *ngIf="profile$ | async as profile"
  [pageTitle]="'LOYALTY.plus.newMemberNotification' | finLocalization: { firstName: profile.firstname }"
  [showPlusCard]="true"
  [showAnnouncementCard]="true"
>
  <fcom-plus-card class="dn-laptop-up center ms-large-b"></fcom-plus-card>

  <fin-announcement-card class="dn-laptop-up block center ms-large-b"></fin-announcement-card>

  <div class="award-and-tier-points-container flex">
    <div class="z1 flex--basis-full">
      <fin-points-balance (ctaClicked)="goUsePoints()"></fin-points-balance>
    </div>
    <div class="z1 flex--basis-full">
      <fin-tier-progress />
    </div>
  </div>

  <div class="mr-large-t mr-large-b">
    <fin-expiring-voucher-notification [vouchers$]="vouchers$"></fin-expiring-voucher-notification>
  </div>

  <fin-milestones class="block mr-large-b" />

  <fin-upgrade-benefits
    [vouchers$]="vouchers$"
    [showLoading$]="transactionsAndBenefitsLoading$"
    class="block mr-large-b"
  ></fin-upgrade-benefits>

  <div [class.is-hidden]="transactionsAndBenefitsLoading$ | async" class="latest-transactions ms-large-b">
    <h3 class="nordic-blue-900-text mr-medium-b mr-large-t">
      {{ 'plus.dashboard.transactionHistory' | finLocalization }}
    </h3>

    <fin-transaction-history
      [initialVisibleTransactionAmount]="3"
      [hideTooltip]="true"
      [showFullHistoryLink]="true"
      [hiddenCaptionText]="'plus.dashboard.transactionHistory' | finLocalization"
    >
    </fin-transaction-history>
  </div>

  <ng-container benefitBanner *finLet="tierBenefits$ | async as benefits">
    <fin-benefit-banner
      *ngIf="benefits.length && (sideBarContent$ | async) as sidebarContent"
      [title]="sidebarContent.teaserTitle"
      [buttons]="[bannerCta$ | async]"
      [invertedColors]="true"
    >
      <div sideContent>
        <cms-unstyled-fragment
          [cmsContent$]="sidebarContent | finToObservable"
          [showTitle]="false"
        ></cms-unstyled-fragment>
      </div>
      <ng-container>
        <fin-tier-benefits [invertedColors]="true" [items]="benefits"></fin-tier-benefits>
      </ng-container>
    </fin-benefit-banner>

    <fin-promotion-segment
      *ngIf="creditCardBannerParams$ | async as params"
      [fragmentUrl]="'LOYALTY.fragments.finnairVisaBenefits.url'"
      [fragmentParams]="params"
    ></fin-promotion-segment>
  </ng-container>
</fin-loyalty-view>
